module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"be-NL":{"logout":"Afmelden","login":"Log in"},"be-EN":{"logout":"Logout","login":"Log in"},"be-FR":{"logout":"Déconnexion","login":"S\u0027identifier"}}')
  delete Component.options._Ctor
}
